import {
    IS_LOADING,
    APPEAL_DATA_SUCCESS,
    APPEALS_TOP_OVERTURN_REASON_DATA_SUCCESS,
    APPEALS_TOP_OVERTURN_REASON_DATA_LOADING,
    SET_APPEAL_STATUS_FILTER,
    APPEALS_TREND_DATA_LOADING,
    APPEALS_TREND_DATA_SUCCESS
} from '../../../actions/actionTypes';
  
interface AppealState {
    appealData: any;
    appealTopOverturnData?: any;
    appealTopOverturnLoading: boolean;
    isLoading: boolean;
    appealsTrendData?: any;
    appealsTrendLoading: boolean;
    appealStatusFilter: {
        title: string;
        value: string;
    };
}
  
const initialState: AppealState = {
    appealData: {},
    appealTopOverturnData: {},
    appealTopOverturnLoading: false,
    isLoading: false,
    appealsTrendData: {},
    appealsTrendLoading: false,
    appealStatusFilter: {
        title: 'All Appeal Status',
        value: 'All',
    }
};
  
const AppealReducer = (
    state = initialState,
    action: { type: string; payload?: any }
): AppealState => {
    switch (action.type) {
        case IS_LOADING:
            return {
                ...state,
                isLoading: action.payload,
            };
  
        case APPEAL_DATA_SUCCESS:
            return {
                ...state,
                appealData: action.payload,
            };
      
        case APPEALS_TOP_OVERTURN_REASON_DATA_SUCCESS:
            return {
                ...state,
                appealTopOverturnData: action.payload,
            };

        case APPEALS_TOP_OVERTURN_REASON_DATA_LOADING:
            return {
                ...state,
                appealTopOverturnLoading: action.payload,
            };    

        case SET_APPEAL_STATUS_FILTER:
            return {
                ...state,
                appealStatusFilter: action.payload,
            };
            
        case APPEALS_TREND_DATA_LOADING:
            return {
                ...state,
                appealsTrendLoading: action.payload,
            };
    
        case APPEALS_TREND_DATA_SUCCESS:
            return {
                ...state,
                appealsTrendData: action.payload,
        };    
  
        default:
            return state;
    }
};
  
export default AppealReducer;
